import React from 'react';

class FilterableTrackTopics extends React.Component {
  constructor(props){
    super(props);
    this.state = {};
  }

  searchBar(placeholder) {
    return (
      <div className="search-bar">
        <input type="text" placeholder={placeholder} onChange={this.onFilterListTextChange.bind(this)}/>
      </div>
    );
  }
  onFilterListTextChange(e){
    this.setState({filterText: e.target.value.trim().toLowerCase()})
  }


  render(){
    const {topics, selected, onSelect} = this.props;
    let selectedMap = selected.map(t => t.id);
    let filtered = topics.filter(topic => selectedMap.indexOf(topic._id.$oid) === -1);

    if(this.state.filterText){
      filtered = filtered.filter(topic => topic.name.toLowerCase().indexOf(this.state.filterText) >= 0);
    }

    return (
      <div>
        { this.searchBar("Search Track Topics") }
        <div className="providers-container">
          {filtered.map(topic => (
            <div className="provider clickable" onClick={() => { onSelect({id: topic._id.$oid }); }}>
              {topic.name}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
//TODO - prop types
export default FilterableTrackTopics;
